<template>
  <a-card title="支付日志列表">
    <div class="table-operator">
      <a-form layout="inline" :form="form">
        <a-form-item :label="$t('system.transaction.transactionId')">
          <a-input
              v-model="queryParam.transactionId"
              :placeholder="$t('system.transaction.placeholderTransactionId')"
          />
        </a-form-item>
        <a-form-item :label="$t('system.transaction.paymentSource')">
          <a-select
              v-model="queryParam.paymentSource"
              :placeholder="$t('system.transaction.placeholderPaymentSource')"
              style="width: 150px"
          >
            <a-select-option value="">全部</a-select-option>
            <a-select-option
                v-for="source in paymentSources"
                :key="source"
                :value="source"
            >
              {{ source }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('system.transaction.createTime')">
          <a-range-picker
              v-model="queryParam.createTimeRange"
              :show-time="{ format: 'HH:mm', defaultValue: [$moment('00:00:00', 'HH:mm:ss'), $moment('23:59:59', 'HH:mm:ss')]}"
              format="YYYY-MM-DD HH:mm:ss"
              :placeholder="[$t('antd.table.startTime'), $t('antd.table.endTime')]"
              @change="onDateChange"
              style="width: 350px"
          />
        </a-form-item>
        <a-form-item>
          <!--          <a-button type="primary" html-type="submit">查询</a-button>-->
          <!--          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>-->
          <a-button type="primary" icon="search" @click="searchQuery(1)" style="margin-right: 8px;">
            {{ $t('antd.table.search') }}
          </a-button>
          <a-button icon="reload" @click="searchReset({},1)" style="margin-right: 8px;">
            {{ $t('antd.table.reset') }}
          </a-button>
        </a-form-item>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator"
         style="margin-top: 5px; display: flex; justify-content: space-between; align-items: center;">
      <div style="flex: 1;">
        <a-button type="primary" icon="download" @click="handleExportXls()" style="margin-right: 8px;">
          {{ $t('antd.table.export') }}
        </a-button>
      </div>
    </div>
    <!-- 统计信息区域 -->
    <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
      <div style="display: flex; gap: 20px; flex-wrap: wrap;">
        <div style="display: flex; align-items: center; gap: 5px">
          <span>{{ $t('system.transaction.totalPayAmount') }}:</span>
          <span style="font-weight: 600; color: #2f54eb">{{ statistics.totalPayAmount }}</span>
          <span style="font-size: 0.8em; margin-left: 1px; color: #666">UZS</span>
        </div>
        <div style="display: flex; align-items: center; gap: 5px">
          <span>{{ $t('system.transaction.totalActualReceivedAmount') }}:</span>
          <span style="font-weight: 600; color: #2f54eb">{{ statistics.totalActualReceivedAmount }}</span>
          <span style="font-size: 0.8em; margin-left: 1px; color: #666">UZS</span>
        </div>
      </div>
    </div>
    <a-table
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        rowKey="id"
        size="middle"
        bordered
        @change="handleTableChange"
        :scroll="{ x: tableScrollX }"
    >
      <template slot="paymentSource" slot-scope="text">
        <a-tag :color="paymentSourceColors[text] || 'default'">
          {{ text }}
        </a-tag>
      </template>
      <template slot="createTime" slot-scope="text">
        {{ text | formatDate }}
      </template>
      <!-- 新增操作列 -->
      <template slot="action" slot-scope="text, record">
        <a @click="handleView(record)">{{ $t('antd.table.infor') }}</a>
      </template>
    </a-table>
    <!-- 添加详情弹窗 -->
    <pay-log-detail
        :visible="detailVisible"
        :transactionId="currentTransactionId"
        :barCodeNoSet="currentBarCodeNoSet"
        @close="detailVisible = false"
    />
  </a-card>
</template>

<script>
import moment from "moment";
import PayLogDetail from './modules/PayLogDetail.vue'; // 引入子组件
import {TableListMixin} from '@/situation/mixins/tableListMixin'
import {filterObj} from "utils/util";

export default {
  mixins: [TableListMixin],
  components: {
    PayLogDetail
  },
  computed: {
    tableScrollX() {
      // 计算所有列宽之和
      return this.columns.reduce((sum, col) => sum + (col.width || 120), 0)
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      // 查询条件
      queryParam: {},
      paymentSources: [], // 从接口获取或手动定义
      paymentSourceColors: {
        '现结': 'red',    // 微信红色系，用于现金交易
        'payme': 'geekblue',   // 微信绿色系，与主色相近
        'WeChat': 'green',  // 微信品牌绿色
        'Alipay': 'blue',  // 支付宝蓝色，与微信形成对比
        'pos': 'cyan',     // 微信黄色系，用于POS机
        'Uzumpal': 'gold'  // 紫色系，保持独特性
      },
      // 原有data保持不变
      detailVisible: false, // 控制详情弹窗显示
      currentTransactionId: '',
      currentBarCodeNoSet: '',
      columns: [
        {
          title: this.$t('system.transaction.transactionId'),
          dataIndex: "transactionId",
          align: "center",
          width: 200,
        },
        {
          title: this.$t('system.transaction.barCodeNoSet'),
          dataIndex: "barCodeNoSet",
          align: "center",
          width: 300,
          customRender: (text) => {
            // 限制最多显示100个字符
            const maxLength = 35;
            const truncatedText = text && text.length > maxLength
                ? text.substring(0, maxLength) + '...'
                : text;

            return {
              children: (
                  <a-tooltip placement="top" title={text}>
                    <span>{truncatedText}</span>
                  </a-tooltip>
              )
            };
          }
        },
        {
          title: this.$t('system.transaction.orderCount'),
          dataIndex: "orderCount",
          align: "center",
          width: 120,
        },{
          title: this.$t('system.transaction.paymentSource'),
          dataIndex: "paymentSource",
          scopedSlots: {customRender: 'paymentSource'},
          align: "center",
          width: 120,
        },
        {
          title: this.$t('system.transaction.payAmount'),
          dataIndex: "payAmount",
          align: "center",
          width: 150,
        },
        {
          title: this.$t('system.transaction.actualReceivedAmount'),
          dataIndex: "actualReceivedAmount",
          align: "center",
          width: 150,
        },
        {
          title: this.$t('system.transaction.createTime'),
          dataIndex: "createTime",
          scopedSlots: {customRender: "createTime"},
          align: "center",
          width: 180,
        },
        {
          title: this.$t('antd.table.batch'),
          key: "action",
          dataIndex: 'action',
          align: "center",
          width: 80,
          scopedSlots: {customRender: "action"}
        }
      ],
      url: {
        selectData: "/ndt/payLog/page",
        statistics: "/ndt/payLog/statistics",
        deleteData: "",
        exportXlsUrl: "/ndt/payLog/export"
      },
    };
  },
  filters: {
    formatDate(value) {
      return value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "-";
    },
  },
  mounted() {
    // this.fetch();
    this.getPaymentSources();
  },
  async created() {
    await this.dataStatistics(); // 加载统计数据
  },
  methods: {
    // 新增查看详情方法
    async handleView(record) {
      this.currentTransactionId = record.transactionId;
      this.currentBarCodeNoSet = record.barCodeNoSet;
      this.detailVisible = true;
    },
    onDateChange: function (value, dateString) {
      console.log(dateString[0], dateString[1]);
      this.queryParam.startTime = dateString[0];
      this.queryParam.endTime = dateString[1];
    },
    getQueryParams() {
      var param = Object.assign({}, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.current = this.ipagination.current;
      param.size = this.ipagination.pageSize;
      delete param.createTimeRange; // 时间参数不传递后台
      if (this.superQueryParams) {
        param['superQueryParams'] = encodeURI(this.superQueryParams)
        param['superQueryMatchType'] = this.superQueryMatchType
      }
      return filterObj(param);
    },
    getPaymentSources() {
      this.paymentSources = ["现结", "payme", "WeChat", "Alipay", "pos", "Uzumpal"];
    },
  },
};
</script>

<style scoped>
.table-operator {
  margin-bottom: 16px;
}
</style>
